<template>
    <div class="edn">
        <p class="desc">{{edn.desc}}</p>
        <div class="tabs pc">
            <template v-for="(item, index) in tabs">
                <div class="item" :key="index">
                    <router-link :to="item.link">{{item.text}}</router-link>
                </div>
                <div class="line" :key="'line_' + index"></div>
            </template>
        </div>
        <div class="tabs mobile">
            <div class="tabs_inner" :style="`width: ${100 * tabs.length}%; transform: translate(${-(100 / tabs.length) * activeIndex}%, 0)`">
                <template v-for="(item, index) in tabs">
                    <div class="item" :key="index" :class="{active: activeIndex == index}">{{item.text}}</div>
                </template>
            </div>
            <div class="btn_prev" v-if="activeIndex > 0" @click="tabsPrev"></div>
            <div class="btn_next" v-if="activeIndex < tabs.length - 1" @click="tabsNext"></div>
        </div>
        <router-view/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "edn",
    data() {
        return {
            activeIndex: 0,
            tabs: [
                { text: '创新服务', link: '/value/edn/innovation'},
                { text: '人才聚合', link: '/value/edn/talent'},
            ]
        };
    },
    computed: {
        ...mapState(['edn'])
    },
    components: {
    },
    mounted() {
        this.$store.dispatch('getEdn');
    },
    destroyed() {},
    watch: {
        $route: {
            handler(){
                for (let i = 0; i < this.tabs.length; i++) {
                    const item = this.tabs[i];
                    if(this.$route.path.indexOf(item.link) != -1){
                        this.$nextTick(()=>{
                            this.activeIndex = i;
                        })
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        tabsPrev(){
            if(this.activeIndex <= 0){
                return false;
            }
            this.activeIndex--;
            this.$router.push(this.tabs[this.activeIndex].link)
        },
        tabsNext(){
            if(this.activeIndex >= this.tabs.length - 1){
                return false;
            }
            this.activeIndex++;
            this.$router.push(this.tabs[this.activeIndex].link)
        },
    },
};
</script>

<style scoped lang="scss">
.edn{
    padding: .8rem 0;
    @media only screen and (max-width: 1200px) {
        padding: 1rem 0;
        .desc{
            padding: 0 1rem;
        }
    }
}
.tabs{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: .5rem 0;
    &.mobile{
        display: none;
    }
    .item{
        font-size: .3rem;
        color: rgba($color: #000000, $alpha: .5);
        a{
            &.active{
                color: #ff4028;
            }
        }
    }
    .line{
        width: 1px;
        height: .5rem;
        background: rgba($color: #ff4028, $alpha: .5);
        margin: 0 1rem;
        &:last-child{
            display: none;
        }
    }
    @media only screen and (max-width: 1200px) {
        position: relative;
        overflow: hidden;
        margin: .8rem 0;
        &.pc{
            display: none;
        }
        &.mobile{
            display: block;
        }
        .tabs_inner{
            display: flex;
            justify-content: center;
            align-items: center;
            transition: transform .5s;
        }
        .item{
            width: 100%;
            height: 1rem;
            font-size: .6rem;
            display: flex;
            align-items: center;
            justify-content: center;
            &.active{
                font-weight: bold;
                color: #ff4836;
            }
        }
        .line{
            display: none;
        }
        .btn_prev,
        .btn_next{
            position: absolute;
            width: .48rem;
            height: .61rem;
            top: 50%;
            transform: translate(0, -50%);
            background: no-repeat center/100%;
        }
        .btn_prev{
            left: 2.8rem;
            background-image: url('~@/assets/images/icon_arrow_prev.svg');
        }
        .btn_next{
            right: 2.8rem;
            background-image: url('~@/assets/images/icon_arrow_next.svg');
        }
    }
}
</style>